import { Container } from 'src/components/common/Container'
import styled, { css } from 'styled-components'
import { GiftedCouponDetailSpace } from 'src/types/api'
import { Typography } from 'src/components/common/Typography'
import {
  Noto_body1_b16,
  Noto_body1_m16,
  Noto_body2_b14,
  Noto_body2_r14,
  Noto_heading3_b20,
} from 'src/styles/fonts/NotoSansKrFonts'
import React from 'react'
import Button, { ButtonOption1 } from 'src/components/common/Button'
import { Divider, SmallDivider } from 'src/components/common/Divider'
import { CouponDetailCard } from 'src/components/common/CouponDetailCardItems'
import Skeleton from 'react-loading-skeleton'
import PurchaseHistoryDetailUnderLineTab from 'src/pages/PurchaseHistoryPage/PurchaseHistoryDetailPage/_components/PurchaseHistoryDetailUnderLineTab'
import CouponCircleImage from 'src/components/common/CouponCircleImage'
import RenderIf from 'src/components/common/RenderIf'
import { getBrandAndCouponName } from 'src/utils'
import { ellip } from 'src/styles/mixin'
import { GiftedCouponDetailPageProps } from 'src/pages/GiftedCouponPage/GiftedCouponDetailPage/index'
import { Icon } from 'src/assets/svg/Icon'
import usePageNav from 'src/hooks/usePageNav.hook'
import { DateUtils } from 'src/utils/date'

const GiftedCouponDetailPageView = (props: GiftedCouponDetailPageProps) => {
  const {
    giftedCouponDetailData,
    giftedCouponDetailDataList,
    cancelSendGiftHandler,
    reShareUrlHandler,
    isSending,
    isSendComplete,
    isCancelAble,
  } = props
  const { couponPurchaseHistoryPageNav, addUtmParameter } = usePageNav()
  const { DateFormat } = DateUtils
  const { CouponName, BrandName, CouponImage, GiftURL, GiftStatus, DecisionDT } =
    giftedCouponDetailData as GiftedCouponDetailSpace.Response
  const isSendCancel = GiftStatus === 3

  const moveToHistory = () => {
    window.history.replaceState({}, '', addUtmParameter('/main'))
    window.history.pushState({}, '', addUtmParameter('/mypage'))
    couponPurchaseHistoryPageNav()
  }

  return (
    <S.GiftedCoupon.Container $option="flex_column" isSendCancel={isSendCancel}>
      <CouponDetailCard.Bg>
        <RenderIf when={isSendCancel}>
          <S.CanceledCoupon.Container $option="flex_column">
            <Typography $fontStyle={Noto_heading3_b20} $color="var(--black-90)">
              선물이 취소되었습니다.
            </Typography>
            <Typography $fontStyle={Noto_body2_r14} $color="rgba(0, 0, 0, 0.7)">
              취소된 선물은 구매내역에서 확인 가능합니다.
              <br />
              선물 취소일 : {DateFormat(DecisionDT, 'YY.MM.DD')}
            </Typography>
            <S.CanceledCoupon.MoveToPurchaseHistoryButton onClick={moveToHistory}>
              구매내역 이동하기
              <Icon.Arrow size="16" rotate="right" color="var(--brand-50)" />
            </S.CanceledCoupon.MoveToPurchaseHistoryButton>
          </S.CanceledCoupon.Container>
        </RenderIf>
        <CouponDetailCard.Container $barcode={false}>
          <CouponDetailCard.Top>
            <CouponCircleImage src={CouponImage} />
            <S.GiftedCoupon.BrandName as={!!CouponName ? 'span' : Skeleton}>
              [{BrandName}]
            </S.GiftedCoupon.BrandName>
            <S.GiftedCoupon.CouponName as={!!CouponName ? 'span' : Skeleton}>
              {getBrandAndCouponName(CouponName).couponName}
            </S.GiftedCoupon.CouponName>
          </CouponDetailCard.Top>
        </CouponDetailCard.Container>
      </CouponDetailCard.Bg>
      <RenderIf when={!isSendCancel}>
        <RenderIf when={isSending || isSendComplete}>
          <S.GiftedCoupon.TopButtonWrap>
            <S.GiftedCoupon.TextButton onClick={() => reShareUrlHandler(GiftURL)}>
              <Typography $fontStyle={Noto_body1_b16} $color="var(--brand-50)">
                링크 다시 전달하기
              </Typography>
            </S.GiftedCoupon.TextButton>
          </S.GiftedCoupon.TopButtonWrap>
        </RenderIf>
        <CouponDetailCard.DetailInfoList>
          {giftedCouponDetailDataList?.map((ele, index: number) => (
            <RenderIf when={!!ele?.label} key={index}>
              <CouponDetailCard.DetailInfoLine
                key={index}
                $disabled={!ele}
                as={ele?.value?.[0]?.text !== '' || !!ele?.value ? 'div' : Skeleton}
              >
                <CouponDetailCard.DetailTitle>{ele?.label}</CouponDetailCard.DetailTitle>
                <span>
                  {ele?.value?.map((value, index) => (
                    <CouponDetailCard.DetailDesc
                      $bold={value?.bold}
                      $color={value?.color}
                      key={index}
                    >
                      {' '}
                      {value?.text}
                    </CouponDetailCard.DetailDesc>
                  ))}
                </span>
              </CouponDetailCard.DetailInfoLine>
            </RenderIf>
          ))}
        </CouponDetailCard.DetailInfoList>
        <SmallDivider />
        <RenderIf when={isCancelAble}>
          <S.GiftedCoupon.MiddleButtonWrap $option="flex_column">
            <Button option={ButtonOption1('default')} onClickFn={cancelSendGiftHandler}>
              선물 취소
            </Button>
            <Typography $fontStyle={Noto_body2_r14} $color="var(--black-50)">
              수락이 거절된 쿠폰은{' '}
              <Typography $fontStyle={Noto_body2_b14}>일반 구매내역</Typography>
              에서 확인 가능합니다.
            </Typography>
          </S.GiftedCoupon.MiddleButtonWrap>
        </RenderIf>
        <Divider />
        <PurchaseHistoryDetailUnderLineTab {...props} />
      </RenderIf>
    </S.GiftedCoupon.Container>
  )
}
export default GiftedCouponDetailPageView

const S = {
  CanceledCoupon: {
    Container: styled(Container)`
      align-items: center;
      text-align: center;
    `,
    MoveToPurchaseHistoryButton: styled.button`
      ${Noto_body2_b14};
      display: flex;
      justify-content: center;
      align-items: center;
      margin: 15px 0;
      width: fit-content;
      gap: 2px;
      color: var(--brand-50);
      word-break: keep-all;
    `,
  },
  GiftedCoupon: {
    Container: styled(Container)<{ isSendCancel: boolean }>`
      ${({ isSendCancel }) =>
        isSendCancel &&
        `
        justify-content: center;
        padding: 60px 0;
        flex: 1;
        background-color: var(--black-10);
      `}
    `,
    TopButtonWrap: styled(Container)`
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      align-items: center;
      background-color: var(--brand-10);
    `,
    MiddleButtonWrap: styled(Container)`
      align-items: center;
      padding: 20px;
      gap: 10px;
      text-align: center;
      word-break: keep-all;
    `,
    TextButton: styled.button`
      display: flex;
      justify-content: center;
      align-items: center;
      height: 58px;
      gap: 3px;

      &:not(:last-child) {
        border-right: 1px solid var(--black-30);
      }
    `,
    BrandName: styled(Typography)`
      margin: 14px 0 6px 0;
      ${Noto_body1_m16};
      color: var(--black-50);
    `,
    CouponName: styled(Typography)`
      ${Noto_heading3_b20};
      color: var(--black-90);
      ${ellip('line2')};
      text-align: center;
    `,
    ValidDay: styled(Typography)`
      ${Noto_body1_m16};
    `,
    RegularPrice: styled(Typography)`
      ${Noto_body1_m16};
    `,
    BarcodeDeem: css`
      width: 284px;
      height: 122px;
      backdrop-filter: blur(2px);
      background: rgba(255, 255, 255, 0.9);
      margin-top: -16px;
      position: absolute;
      z-index: 1;
      left: 50%;
      transform: translate(-50%, 0);
      gap: 10px;
      align-items: center;
      justify-content: center;
    `,
    BarcodeStatusIcon: styled.img`
      display: flex;
      width: 35px;
      height: 34px;
      margin: 0 auto;
    `,
  },
}
